export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/mini-program-company-qr-53720ac160880dad20ad46f2924374ad.png";